// src/utils/landingText.js

export const landingText = {
  heading: 'Get Free Access',
  highlightedText: 'To Our Smart',
  subheading:
    'Experience intelligent document processing,ID verification, and customer engagement with our free trial platform. No commitment, just results.',
  buttonLabel: 'Get Started',
};

export default landingText;
